import { IGetContasPagarByIdUseCase } from "../../../presentation/useCases/read/get_contas_pagar_by_id_use_case";
import { ContasPagar } from "../../models/contas_pagar";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContasPagarByIdUseCase
 */

export class GetContasPagarByIdUseCase implements IGetContasPagarByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getContasPagarById(idContasPagar: number): Promise<ContasPagar> {
    return await this.repository.getContasPagarById(idContasPagar);

  }
}
